// extracted by mini-css-extract-plugin
export var showMoreIcon = "styles-module--showMore-icon--831f8";
export var showMoreText = "styles-module--showMore-text--9f80c";
export var showMoreWrapper = "styles-module--showMore-wrapper--41cf0";
export var suptitle = "styles-module--suptitle--cf8fb";